import { all } from 'redux-saga/effects';
import commonSagas from './common';
import authSagas from './auth';
import mentorSagas from './mentor';
import courseSagas from './course';
import adminSagas from './admin';
import studentSagas from './student';
import quizSagas from './quiz';

export default function* rootSaga() {
  yield all([
    commonSagas(),
    authSagas(),
    mentorSagas(),
    courseSagas(),
    adminSagas(),
    studentSagas(),
    quizSagas()
  ]);
}
